module.exports = __webpack_public_path__ + "static/media/reported_outcomes_big.0910aac8.png";